import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-autres-assurances',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent, RouterModule],
  templateUrl: './autres-assurances.component.html',
  styleUrls: ['./autres-assurances.component.scss']
})
export class AutresAssurancesComponent {
  title = 'Autres Assurances';
  subtitle = 'Découvrez toute notre gamme de solutions d\'assurance';
  heroImage = 'assets/static_pages_images/autres-assurances.jpg';
  
  breadcrumbs = [
    { label: 'Accueil', link: '/landing' },
    { label: 'Nos Assurances' }
  ];

  prevPage = {
    title: 'Crédit Professionnel',
    link: '/assurance-credit-professionnel'
  };

  nextPage = {
    title: 'Comparateur',
    link: '/comparaison'
  };

  // Toutes les assurances regroupées par catégorie
  assuranceCategories = [
    {
      title: 'Assurance des Personnes - Particuliers',
      icon: '👤',
      color: '#9333ea',
      assurances: [
        { name: 'Mutuelle Santé Individuelle', link: '/assurance-mutuelle-sante-individuelle' },
        { name: 'Mutuelle Santé Internationale', link: '/assurance-mutuelle-sante-internationale' },
        { name: 'Prévoyance GAV', link: '/assurance-prevoyance-gav' },
        { name: 'Prévoyance IJH', link: '/assurance-prevoyance-ijh' },
        { name: 'Prévoyance Obsèque', link: '/assurance-prevoyance-obseque' },
        { name: 'Prévoyance Décès', link: '/assurance-prevoyance-deces' },
        { name: 'Retraite Complémentaire Salarié', link: '/assurance-retraite-complementaire-salarie' },
        { name: 'Voyage Personnel', link: '/assurance-voyage-personnel' },
        { name: 'Crédit – Assurance Emprunteur', link: '/assurance-credit-emprunteur' }
      ]
    },
    {
      title: 'Assurance des Personnes - Pro/Entreprises',
      icon: '🏢',
      color: '#00c4cc',
      assurances: [
        { name: 'Mutuelle Santé Professionnelle', link: '/assurance-mutuelle-sante-professionnelle' },
        { name: 'Mutuelle Santé Internationale Pro', link: '/assurance-mutuelle-sante-internationale-pro' },
        { name: 'Mutuelle Santé Entreprise', link: '/assurance-mutuelle-sante-entreprise' },
        { name: 'Prévoyance Professionnelle', link: '/assurance-prevoyance-professionnelle' },
        { name: 'Prévoyance Entreprise', link: '/assurance-prevoyance-entreprise' },
        { name: 'Retraite Complémentaire Pro', link: '/assurance-retraite-complementaire-pro' },
        { name: 'Retraite Complémentaire Entreprise', link: '/assurance-retraite-complementaire-entreprise' },
        { name: 'Voyage Professionnel', link: '/assurance-voyage-professionnel' }
      ]
    },
    {
      title: 'Assurance des Biens - Particuliers',
      icon: '🏠',
      color: '#10b981',
      assurances: [
        { name: 'Multirisque Habitation', link: '/assurance-multirisque-habitation' },
        { name: 'Auto Personnelle', link: '/assurance-auto-personnelle' },
        { name: 'Moto Personnelle', link: '/assurance-moto-personnelle' },
        { name: 'Auto Temporaire', link: '/assurance-auto-temporaire' },
        { name: 'Multirisque Immeuble – MRI – PNO', link: '/assurance-multirisque-immeuble-pno' },
        { name: 'Loyers Impayés', link: '/assurance-loyers-impayes' },
        { name: 'Protection Juridique', link: '/assurance-protection-juridique' },
        { name: 'Œuvres d\'Art – Bijoux', link: '/assurance-oeuvres-art-bijoux' },
        { name: 'Dommages Ouvrage', link: '/assurance-dommages-ouvrage' },
        { name: 'Chiens – Chats – Animaux', link: '/assurance-animaux' },
        { name: 'Vélo – Trottinette Électrique', link: '/assurance-velo-trottinette' }
      ]
    },
    {
      title: 'Assurance des Biens - Pro/Entreprises',
      icon: '🏭',
      color: '#f59e0b',
      assurances: [
        { name: 'Auto Professionnelle', link: '/assurance-auto-professionnelle' },
        { name: 'Moto Professionnelle', link: '/assurance-moto-professionnelle' },
        { name: 'Flotte Auto Professionnelle', link: '/assurance-flotte-auto-professionnelle' },
        { name: 'Flotte Moto Professionnelle', link: '/assurance-flotte-moto-professionnelle' },
        { name: 'Multirisque Professionnelle', link: '/assurance-multirisque-professionnelle' },
        { name: 'Multirisque Immeuble – MRI – PNE', link: '/assurance-multirisque-immeuble-pne' },
        { name: 'Bris de Machine', link: '/assurance-bris-de-machine' },
        { name: 'Risque Cybersécurité – Cyberattaque', link: '/assurance-cyber-securite' },
        { name: 'Loueur de Véhicules', link: '/assurance-loueur-vehicules' },
        { name: 'Marchandises Transportées', link: '/assurance-marchandises-transportees' }
      ]
    },
    {
      title: 'Assurance de l\'Activité - Pro/Entreprises',
      icon: '⚖️',
      color: '#ef4444',
      assurances: [
        { name: 'Responsabilité Civile', link: '/assurance-responsabilite-civile' },
        { name: 'RC Mandataires Sociaux', link: '/assurance-rc-mandataires-sociaux' },
        { name: 'RC Décennale', link: '/assurance-rc-decennale' },
        { name: 'Protection Juridique Professionnelle', link: '/assurance-protection-juridique-pro' },
        { name: 'Perte d\'Exploitation', link: '/assurance-perte-exploitation' },
        { name: 'Homme-Clé', link: '/assurance-homme-cle' },
        { name: 'Crédit Professionnel', link: '/assurance-credit-professionnel' }
      ]
    }
  ];

    constructor(private router: Router) {}

  navigateToComparison(): void {
  this.router.navigate(['/comparateur']);
}
}
